import { type StrapiMetaType } from "@/types/strapi.type";

export const fetchStrapi = async <T>(
  endpoint: string,
  options?: RequestInit
): Promise<{
  data: T | null;
  meta: StrapiMetaType["meta"] | null;
  error?: Error;
}> => {
  try {
    if (!process.env.STRAPI_URL) throw new Error("STRAPI_URL is not set");
    if (!process.env.STRAPI_TOKEN) throw new Error("STRAPI_TOKEN is not set");
  } catch (error) {
    console.error("Strapi is not configured");
    return { data: null, meta: null, error } as {
      data: null;
      meta: null;
      error: Error;
    };
  }

  const headers = new Headers(options?.headers);
  headers.set("Accept", "application/json");
  headers.set("Content-Type", "application/json");
  headers.set("Authorization", `Bearer ${process.env.STRAPI_TOKEN}`);

  return fetch(`${process.env.STRAPI_API_URL}${endpoint}`, {
    credentials: "include",
    method: "GET",
    ...options,
    headers,
  })
    .then((res) => res.json())
    .then(
      (payload) =>
        payload as { data: T | null; meta: StrapiMetaType["meta"] | null }
    )
    .catch((error: Error) => {
      console.error(
        "Fetching data from Strapi failed:",
        error.message,
        "\n",
        error.cause
      );
      return { data: null, meta: null, error };
    });
};
